module.exports = __webpack_public_path__ + "23853f2b3b84623a8bf33da041a8128d.svg";